module.exports = __webpack_public_path__ + "img/tracker-icon.27a9522c.svg";